module.exports = {"serverUrl":"https://afternoon-sea-82497.herokuapp.com"};


// WEBPACK FOOTER //
// external "{/"serverUrl/":/"https:/afternoon-sea-82497.herokuapp.com/"}"